export const recaptchaReady = async () => {
    return new Promise<void>((resolve) => {
        window.grecaptcha.ready(() => {
            resolve();
        });
    });
};
